import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { waLink } from './analytics';
import './App.css';
import './Pricing.css';

function SocialMediaManagement() {
  const [expanded, setExpanded] = useState({});

  const socialMediaPackages = [
    {
      name: 'Social Media Starter',
      price: '699.000',
      period: 'bulan',
      description: 'Solusi awal untuk brand yang ingin mulai membangun kehadiran di media sosial',
      features: [
        'Perencanaan konten',
        'Desain posting basic',
        'Manajemen 1 platform',
        'Strategi pertumbuhan audience dasar',
        'Laporan bulanan',
        'Support via WhatsApp',
        'Content calendar basic'
      ],
      popular: false,
      color: '#ef4444',
      icon: '📱',
      guarantee: '30 hari garansi kepuasan'
    },
    {
      name: 'Social Media Growth',
      price: '1.299.000',
      period: 'bulan',
      description: 'Untuk brand yang ingin meningkatkan engagement dan reach di media sosial',
      features: [
        'Perencanaan konten strategis',
        'Desain posting profesional',
        'Manajemen 2-3 platform',
        'Strategi pertumbuhan audience lanjutan',
        'Campaign management',
        'Laporan performa detail',
        'Support priority',
        'A/B testing content'
      ],
      popular: true,
      color: '#ef4444',
      icon: '📱',
      guarantee: '30 hari garansi kepuasan'
    },
    {
      name: 'Social Media Scale',
      price: '2.199.000',
      period: 'bulan',
      description: 'Strategi komprehensif untuk brand yang ingin mendominasi media sosial',
      features: [
        'Strategi konten komprehensif',
        'Desain kreatif & video content',
        'Manajemen multi-platform',
        'Strategi pertumbuhan agresif',
        'Campaign management advanced',
        'Influencer collaboration',
        'Laporan analitik mendalam',
        'Support dedicated',
        'Monthly strategy review'
      ],
      popular: false,
      color: '#ef4444',
      icon: '📱',
      guarantee: '30 hari garansi kepuasan'
    }
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <span key={i} className={`star ${i < rating ? 'filled' : ''}`}>★</span>
    ));
  };

  return (
    <>
      <section className="pricing-hero">
        <div className="pricing-hero__inner">
          <div className="pricing-hero__content">
            <span className="pricing-hero__badge">📱 Social Media Management</span>
            <h1 className="pricing-hero__title">
              Social Media Management
              <span className="pricing-hero__title-accent">Brand Presence</span>
            </h1>
            <p className="pricing-hero__subtitle">
              Layanan pengelolaan media sosial untuk membantu brand membangun kehadiran digital, 
              meningkatkan engagement, dan menjangkau audiens yang lebih luas secara konsisten.
            </p>
            <div className="pricing-hero__stats">
              <div className="pricing-hero__stat">
                <div className="pricing-hero__stat-number">500+</div>
                <div className="pricing-hero__stat-label">Campaigns Managed</div>
              </div>
              <div className="pricing-hero__stat">
                <div className="pricing-hero__stat-number">85%</div>
                <div className="pricing-hero__stat-label">Avg. Engagement Rate</div>
              </div>
              <div className="pricing-hero__stat">
                <div className="pricing-hero__stat-number">24/7</div>
                <div className="pricing-hero__stat-label">Content Monitoring</div>
              </div>
            </div>
            <div className="pricing-hero__trust">
              <div className="trust-badges">
                <div className="trust-badge">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                  <span>Garansi Engagement</span>
                </div>
                <div className="trust-badge">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 15a3 3 0 100-6 3 3 0 000 6z"/>
                    <path d="M12 7v3m0 0v.01M12 21a9 9 0 110-18 0 9 9 0 010 18z"/>
                  </svg>
                  <span>Support Priority</span>
                </div>
                <div className="trust-badge">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                  <span>Content Strategy</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pricing-cards">
        <div className="pricing-cards__inner">
          <div className="pricing-grid">
            {socialMediaPackages.map((pkg, index) => (
              <div key={pkg.name} className={`pricing-card ${pkg.popular ? 'popular' : ''}`} style={{ '--accent-color': pkg.color }}>
                {pkg.popular && (
                  <div className="pricing-card__badge">
                    <span className="pricing-card__badge-icon">{pkg.icon}</span>
                    <span className="pricing-card__badge-text">Most Popular</span>
                  </div>
                )}
                
                <div className="pricing-card__header">
                  <div className="pricing-card__icon-wrapper">
                    <div className="pricing-card__icon">{pkg.icon}</div>
                  </div>
                  <h3 className="pricing-card__name">{pkg.name}</h3>
                  <p className="pricing-card__description">{pkg.description}</p>
                  <div className="pricing-card__price">
                    <span className="pricing-card__currency">Rp</span>
                    <span className="pricing-card__amount">{pkg.price}</span>
                    <span className="pricing-card__period">/{pkg.period}</span>
                  </div>
                  <div className="pricing-card__value">
                    <span className="pricing-card__value-text">Best Value</span>
                    <div className="pricing-card__value-stars">
                      {renderStars(5)}
                    </div>
                  </div>
                </div>

                <div className="pricing-card__features">
                  <div className="pricing-card__features-header">
                    <span className="pricing-card__features-count">{pkg.features.length} Features</span>
                    <span className="pricing-card__features-included">All Included</span>
                  </div>
                  <ul className="pricing-card__features-list">
                    {(expanded[pkg.name] ? pkg.features : pkg.features.slice(0, 6)).map((feature, featureIndex) => (
                      <li key={featureIndex} className="pricing-card__feature">
                        <div className="pricing-card__check-wrapper">
                          <svg className="pricing-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M20 6L9 17l-5-5"/>
                          </svg>
                        </div>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                  {pkg.features.length > 6 && (
                    <button
                      className="pricing-card__toggle"
                      onClick={() => setExpanded(prev => ({ ...prev, [pkg.name]: !prev[pkg.name] }))}
                    >
                      {expanded[pkg.name] ? 'Show Less' : `Show ${pkg.features.length - 6} More`}
                    </button>
                  )}
                </div>

                <div className="pricing-card__action">
                  <a
                    href={waLink(`Halo, saya ingin memilih paket Social Media Management: ${pkg.name}. Mohon info lebih lanjut.`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pricing-card__btn pricing-card__btn-primary"
                  >
                    <span className="pricing-card__btn-text">Pilih Paket</span>
                    <svg className="pricing-card__btn-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
                    </svg>
                  </a>
                  <div className="pricing-card__guarantee">
                    <div className="pricing-card__guarantee-icon">🛡️</div>
                    <div className="pricing-card__guarantee-text">
                      <div className="pricing-card__guarantee-title">{pkg.guarantee}</div>
                      <div className="pricing-card__guarantee-subtitle">100% Kepuasan</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pricing-faq">
        <div className="pricing-faq__inner">
          <div className="pricing-faq__header">
            <h2 className="pricing-faq__title">Pertanyaan yang Sering Diajukan</h2>
            <p className="pricing-faq__subtitle">Jawaban untuk membantu Anda membuat keputusan yang tepat</p>
          </div>
          <div className="pricing-faq__grid">
            <div className="faq-item">
              <h3 className="faq-item__question">Platform media sosial apa saja yang dikelola?</h3>
              <p className="faq-item__answer">
                Kami mengelola Instagram, Facebook, Twitter, LinkedIn, dan TikTok. 
                Platform disesuaikan dengan target audience dan tujuan bisnis Anda.
              </p>
            </div>
            <div className="faq-item">
              <h3 className="faq-item__question">Apakah konten disesuaikan dengan brand?</h3>
              <p className="faq-item__answer">
                Ya! Kami membuat content strategy dan visual yang disesuaikan 100% dengan 
                brand identity, tone of voice, dan tujuan bisnis Anda.
              </p>
            </div>
            <div className="faq-item">
              <h3 className="faq-item__question">Berapa kali posting dalam seminggu?</h3>
              <p className="faq-item__answer">
                Starter: 3-5 posting/minggu, Growth: 5-7 posting/minggu, Scale: 7-10 posting/minggu. 
                Disesuaikan dengan platform dan strategi konten.
              </p>
            </div>
            <div className="faq-item">
              <h3 className="faq-item__question">Apakah ada iklan berbayar?</h3>
              <p className="faq-item__answer">
                Iklan berbayar tidak termasuk dalam paket management. 
                Kami bisa membantu setup iklan dengan biaya terpisah sesuai budget.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="pricing-cta">
        <div className="pricing-cta__inner">
          <div className="pricing-cta__content">
            <h2 className="pricing-cta__title">Butuh Strategi Social Media Kustom?</h2>
            <p className="pricing-cta__subtitle">
              Kami juga menyediakan strategi social media yang disesuaikan sepenuhnya dengan kebutuhan unik bisnis Anda. 
              Konsultasi gratis untuk membantu menemukan solusi yang tepat.
            </p>
            <div className="pricing-cta__buttons">
              <Link to="/consultation" className="btn btn-primary btn-large">
                <span className="btn__icon">💬</span>
                <span>Konsultasi Gratis</span>
              </Link>
              <a href={waLink('Halo, saya ingin konsultasi Social Media Management. Mohon info lebih lanjut.')} target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-large">
                <span className="btn__icon">📱</span>
                <span>Chat WhatsApp</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SocialMediaManagement;
